import { roundDownToMultipleOf60 } from './helpers';
import 'url-search-params-polyfill';

const removeBrandNameAtBeginning = (text, brand) => {
  if (text.toLowerCase().startsWith(brand.toLowerCase())) {
    let res = text.substring(brand.length);
    if (res.charAt(0) === ' ') {
      res = res.substring(1);
    }
    return res;
  }
  return text;
};

const genImageAlt = (model, brand, color) => {
  if (color) {
    return `${brand} ${removeBrandNameAtBeginning(model, brand)} - ${color}`;
  }
  return `${brand} ${removeBrandNameAtBeginning(model, brand)}`;
};

const defaultQueryValues = {
  on_sale: ['0'],
  page: ['search'],
  sort_field: ['insert_time', 'pv_insert_time'],
  q: [''],
  limit: ['60'],
  skip: ['0'],
};

const keys = {
  onSale: 'on_sale',
  categories: 'categories[]',
  brands: 'brands',
  seasons: 'seasons',
  sizes: 'sizes',
  page: 'page',
  sortField: 'sort_field',
  query: 'q',
  limit: 'limit',
  skip: 'skip',
};

const orderedPermittedQueryParams = [
  keys.onSale,
  keys.categories,
  keys.brands,
  keys.seasons,
  keys.sizes,
  keys.page,
  keys.sortField,
  keys.query,
  keys.skip,
];

const removeDefaultParams = query => {
  Object.keys(query).forEach(key => {
    const lowercaseParamValue = query[key].toString().toLowerCase();
    if (defaultQueryValues[key] && defaultQueryValues[key].includes(lowercaseParamValue)) {
      delete query[key];
    }
  });
  return query;
};

const getOrderedPermittedParamsLowercase = queryParams => {
  const allParams = new URLSearchParams(queryParams);
  const filteredParams = new URLSearchParams();

  orderedPermittedQueryParams.forEach(param => {
    if (allParams.has(param)) {
      filteredParams.set(param.toLowerCase(), allParams.get(param));
    }
  });

  return filteredParams;
};

const deleteUnnecessaryCategoryParam = (path, params) => {
  const { skip: categoriesKey } = keys;
  if (params.has(categoriesKey)) {
    const endingSlashRegex = /\/$/;
    const pathWithoutEndingSlash = path.replace(endingSlashRegex, '');

    const categoryNumber = /(\d)+$/;
    const categoryId = pathWithoutEndingSlash.match(categoryNumber);

    if (params.get(categoriesKey) === categoryId) {
      delete params[categoriesKey];
    }
  }

  return params;
};

const roundSkipParam = params => {
  const { skip: skipKey } = keys;
  if (params.has(skipKey)) {
    params.set(skipKey, roundDownToMultipleOf60(params.get(skipKey)));
  }

  return params;
};

const getCanonicalUrl = (hostname, path, query) => {
  if (!hostname || !path || !query) {
    return null;
  }

  const queryWithoutDefaults = removeDefaultParams(query);
  const permittedLowercaseParams = getOrderedPermittedParamsLowercase(queryWithoutDefaults);
  const paramsWithoutUnnecessaryCategoryParam = deleteUnnecessaryCategoryParam(path, permittedLowercaseParams);
  const finalParams = roundSkipParam(paramsWithoutUnnecessaryCategoryParam);

  const paramsString = finalParams.toString() ? `?${finalParams.toString()}` : '';
  const hostAndPathString = `https://${hostname}${path.replace(/\/$/, '')}`;

  return `${hostAndPathString}/${paramsString}`.toLowerCase();
};

export { getCanonicalUrl, genImageAlt };
